import logo from './logo.svg';
import './App.css';
import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  useLocation
} from "react-router-dom";
import store from './redux/store';

import { getUser } from './redux/action';
import { Provider, useDispatch, useSelector } from 'react-redux';
import Header from './Path/Header';
import NotFound from './Path/NotFound';
import SideBar from './Path/SideBar';

import { slugs } from './Constant/slugs';
import HomeScreenLogin from './Path/Login/HomeScreen';
import LoginScreen from './Path/SignIn';
import Profile from './Path/Profile';
import AllBatch from './Path/Admin/Batch';
import NewBatch from './Path/Admin/Batch/AddNew';
import BatchDetails from './Path/Admin/Batch/Details';
import AllEmployee from './Path/Admin/Employee';
import NewEmployee from './Path/Admin/Employee/AddNew';
import EmployeeDetails from './Path/Admin/Employee/Details';
import AllExpenses from './Path/Admin/Expenses';
import NewExpenses from './Path/Admin/Expenses/AddNew';
import ExpensesDetails from './Path/Admin/Expenses/Details';
import AllInvoices from './Path/Admin/invoices';
import NewInvoices from './Path/Admin/invoices/AddNew';
import InvoiceDetails from './Path/Admin/invoices/Details';
import AllPaymentReceived from './Path/Admin/PaymentReceived';
import NewPaymentReceived from './Path/Admin/PaymentReceived/AddNew';
import PaymentsReceivedDetails from './Path/Admin/PaymentReceived/Details';
import AllStudent from './Path/Admin/Students';
import NewStudent from './Path/Admin/Students/AddNew';
import StudentDetails from './Path/Admin/Students/Details';
import NewTeachers from './Path/Admin/Teachers/AddNew';
import TeachersDetails from './Path/Admin/Teachers/Details';
import AllUsers from './Path/Admin/Users';
import NewUsers from './Path/Admin/Users/AddNew';
import UsersDetails from './Path/Admin/Users/Details';
import AllTeachers from './Path/Admin/Employee/AllTeachers';
import AllTeachersAccount from './Path/Account/Employee/AllTeachers';
import NewEmployeeAccount from './Path/Account/Employee/AddNew';
import EmployeeDetailsAccount from './Path/Account/Employee/Details';
import AllEmployeeAccount from './Path/Account/Employee';
import AllPaymentReceivedAccount from './Path/Account/PaymentReceived';
import PaymentsReceivedDetailsAccount from './Path/Account/PaymentReceived/Details';
import NewPaymentReceivedAccount from './Path/Account/PaymentReceived/AddNew';
import Topics from './Path/Account/topics';

export default class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <AppMain />
        </Router>
      </Provider>
    );
  }
}

function AppMain() {
  const [loginState, setLoginState] = React.useState(true)
  const dispatch = useDispatch()
  const myState = useSelector((state) => state.LocationState);
  const Login = useSelector((state) => state.LoginState);
  const location = useLocation()

  const [menuExpand, setMenuExpand] = React.useState(false)
  useEffect(() => {
    var lastreload = localStorage.getItem("reload")
    const today = new Date().toISOString().split("T")[0];
    if (lastreload !== today) {
      localStorage.setItem("reload", today)
      window.location.reload()
    }
    dispatch(getUser())
    setLoginState(Login.isLoading)
  }, [])
  return (
    <div className="overflow-x-hidden" >
      {Login.token == null ?
        <>
          <Header setMenuExpand={setMenuExpand} menuExpand={menuExpand} />
          <Switch>
            <Route exact path="/"><LoginScreen /></Route>
            <Route exact path="/login"><LoginScreen /></Route>

            {/* <Route path={slugs.all_batches}><AllBatch /></Route>
            <Route path={slugs.new_batch}><NewBatch /></Route>
            <Route path={`${slugs.batches_details}:slug`}><BatchDetails /></Route> */}

            <Route path="*"><LoginScreen /></Route>
          </Switch>
        </>
        :
        <div className="row" >
          {!location.pathname.includes("start") &&
            <div className="sidebar-width-expand" style={{ borderRight: "3px solid #e4e4e4" }} >
              <div className={"sidebar-design"}>
                <div style={{ backgroundColor: "#fff" }} >
                  <SideBar menuExpand={menuExpand} />
                </div>
              </div>
            </div>
          }

          {menuExpand &&
            <div className="sidebar-small-screen ">
              <div className={"sidebar-design"} >
                <SideBar setMenuExpand={setMenuExpand} />
              </div>
            </div>
          }

          <div className={!location.pathname.includes("start") ? "main-width-expand" : "main-width-full"} style={{ backgroundColor: "#f3f3f3" }}>
            {!location.pathname.includes("start") &&
              <Header setMenuExpand={setMenuExpand} menuExpand={menuExpand} />
            }
            <div>
              {(Login.userRole == "author") &&
                <Switch>
                  <Route exact path="/"><AllBatch /></Route>

                  <Route path={slugs.all_batches}><AllBatch /></Route>
                  <Route path={slugs.new_batch}><NewBatch /></Route>
                  <Route path={`${slugs.batches_details}:slug`}><BatchDetails /></Route>

                  <Route path={slugs.all_employee}><AllEmployee /></Route>
                  <Route path={slugs.new_employee}><NewEmployee /></Route>
                  <Route path={`${slugs.employee_details}:slug`}><EmployeeDetails /></Route>

                  <Route path={slugs.all_expenses}><AllExpenses /></Route>
                  <Route path={slugs.new_expenses}><NewExpenses /></Route>
                  <Route path={`${slugs.expenses_details}:slug`}><ExpensesDetails /></Route>

                  <Route path={slugs.all_invoices}><AllInvoices /></Route>
                  <Route path={slugs.new_invoices}><NewInvoices /></Route>
                  <Route path={`${slugs.invoices_details}:slug`}><InvoiceDetails /></Route>

                  <Route path={slugs.all_payments_received}><AllPaymentReceived /></Route>
                  <Route path={slugs.new_payments_received}><NewPaymentReceived /></Route>
                  <Route path={`${slugs.payments_received_details}:slug`}><PaymentsReceivedDetails /></Route>

                  <Route path={slugs.all_students}><AllStudent /></Route>
                  <Route path={slugs.new_students}><NewStudent /></Route>
                  <Route path={`${slugs.students_details}:slug`}><StudentDetails /></Route>

                  <Route path={slugs.all_teachers}><AllTeachers /></Route>
                  <Route path={slugs.new_teachers}><NewEmployee /></Route>
                  <Route path={`${slugs.teachers_details}:slug`}><EmployeeDetails /></Route>

                  <Route path={slugs.all_user_data}><AllUsers /></Route>
                  <Route path={slugs.new_user_data}><NewUsers /></Route>
                  <Route path={`${slugs.user_data_details}:slug`}><UsersDetails /></Route>
                  <Route path={`/topics`}><Topics /></Route>


                  <Route exact path="/profile"><Profile /></Route>
                  <Route path="*"><NotFound /></Route>
                </Switch>
              }

              {Login.userRole == "subscriber" &&
                <Switch>

                  <Route exact path="/">

                    <Profile />
                  </Route>
                  <Route exact path="/profile"><Profile /></Route>
                  <Route path={`/topics`}><Topics /></Route>

                  <Route path={slugs.all_batches}><AllBatch /></Route>
                  <Route path={slugs.new_batch}><NewBatch /></Route>
                  <Route path={`${slugs.batches_details}:slug`}><BatchDetails /></Route>

                  <Route path={slugs.all_students}><AllStudent /></Route>
                  <Route path={slugs.new_students}><NewStudent /></Route>
                  <Route path={`${slugs.students_details}:slug`}><StudentDetails /></Route>

                  <Route path={slugs.all_teachers}><AllTeachersAccount /></Route>
                  <Route path={slugs.new_teachers}><NewEmployeeAccount /></Route>
                  <Route path={`${slugs.teachers_details}:slug`}><EmployeeDetailsAccount /></Route>

                  <Route path={slugs.all_employee}><AllEmployeeAccount /></Route>
                  <Route path={slugs.new_employee}><NewEmployeeAccount /></Route>
                  <Route path={`${slugs.employee_details}:slug`}><EmployeeDetailsAccount /></Route>

                  <Route path={slugs.all_payments_received}><AllPaymentReceivedAccount /></Route>
                  <Route path={slugs.new_payments_received}><NewPaymentReceivedAccount /></Route>
                  <Route path={`${slugs.payments_received_details}:slug`}><PaymentsReceivedDetailsAccount /></Route>

                  <Route path={slugs.all_invoices}><AllInvoices /></Route>
                  <Route path={slugs.new_invoices}><NewInvoices /></Route>
                  <Route path={`${slugs.invoices_details}:slug`}><InvoiceDetails /></Route>

                  <Route path="*"><NotFound /></Route>
                </Switch>
              }
            </div>
          </div>
        </div>
      }

    </div >
  )
}
